import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { COLORS } from "utils/lists.utils";
import { AuthContext } from "./auth.context";

// const createData = (requestedBy, subject, id, status, createdAt, lastActivity) => {
// 	return {
// 		requestedBy,
// 		subject,
// 		id,
// 		status,
// 		createdAt,
// 		lastActivity,
// 	};
// };

const ROWS = {
	open: [
		{
			id: "1",
			requestedBy: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[3] },
			subject: "Re-opening the lock of the July the 15th 2022",
			tId: "T-112331",
			status: "OPEN",
			createdAt: "27/04/2022 12:40",
			lastActivity: "27/04/2022 12:50",
			assignedTo: "Can Karaman",
			messages: [
				{
					sender: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[5] },
					date: new Date(),
					message: "Test Message",
				},
				{
					sender: { company: "C&D Compta", user: "Can Karaman", color: COLORS[3] },
					date: new Date(),
					message: "Test Response",
				},
				{
					sender: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[5] },
					date: new Date(),
					message: "Test Message",
				},
				{
					sender: { company: "C&D Compta", user: "Can Karaman", color: COLORS[3] },
					date: new Date(),
					message: "Test Response",
				},
				{
					sender: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[5] },
					date: new Date(),
					message: "Test Message",
				},
				{
					sender: { company: "C&D Compta", user: "Can Karaman", color: COLORS[3] },
					date: new Date(),
					message: "Test Response",
				},
				{
					sender: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[5] },
					date: new Date(),
					message: "Test Message",
				},
				{
					sender: { company: "C&D Compta", user: "Can Karaman", color: COLORS[3] },
					date: new Date(),
					message: "Test Response",
				},
				{
					sender: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[5] },
					date: new Date(),
					message: "Test Message",
				},
				{
					sender: { company: "C&D Compta", user: "Can Karaman", color: COLORS[3] },
					date: new Date(),
					message: "Test Response2",
				},
			],
		},
		{
			id: "2",
			requestedBy: { user: "Kate Bush", color: COLORS[3] },
			subject: "Just wanted to say hi",
			tId: "T-112332",
			status: "OPEN",
			createdAt: "27/04/2022 12:40",
			lastActivity: "27/04/2022 12:50",
			assignedTo: "Can Karaman",
			messages: [
				{
					sender: { user: "Kate Bush", color: COLORS[3] },
					date: new Date(),
					message: "Test Message",
				},
			],
		},
	],
	closed: [
		{
			id: "3",
			requestedBy: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[3] },
			subject: "Re-opening the lock of the July the 15th 2022",
			tId: "T-112333",
			status: "CLOSED",
			createdAt: "27/04/2022 12:40",
			lastActivity: "27/04/2022 12:50",
			assignedTo: "Can Karaman",
			messages: [
				{
					sender: { company: "Spotify Limited", user: "Victoria DeAngelis", color: COLORS[3] },
					date: new Date(),
					message: "Test Message",
				},
			],
		},
	],
};

export const COLUMNS = [
	{
		key: "requestedBy",
		headerName: "Requested By",
		span: 2,
		valueGetter: (value) => {
			return (
				<>
					{value?.company && <span className="w600">{value.company} / </span>}
					{value.user}
				</>
			);
		},
	},
	{
		key: "subject",
		headerName: "Subject",
		span: 2,
	},
	{
		key: "tId",
		headerName: "Ticket ID",
		span: 1,
	},
	{
		key: "status",
		headerName: "Status",
		span: 1,
	},
	{
		key: "createdAt",
		headerName: "Created Date",
		span: 1.5,
	},
	{
		key: "lastActivity",
		headerName: "Last Activity",
		span: 1.5,
	},
];

export const TicketsContext = createContext({
	tickets: {},
	shownTickets: [],
	changeTab: () => {},
	deleteTickets: () => {},
	getTicketById: () => {},
	respond: () => {},
	createTicket: () => {},
	closeTicket: () => {},
});

const TicketsProvider = ({ children }) => {
	const { user } = useContext(AuthContext);

	const { companyColor, name, surname, companyName } = useMemo(() => {
		return user ?? { companyColor: "", name: "", surname: "", companyName: null };
	}, [user]);

	const [tickets, setTickets] = useState(ROWS);
	const [selectedTab, setSelectedTab] = useState(0);

	const shownTickets = useMemo(() => {
		return Object.values(tickets)[selectedTab] ?? [];
	}, [tickets, selectedTab]);

	const changeTab = useCallback((tabIndex) => {
		setSelectedTab(tabIndex);
	}, []);

	const deleteTickets = useCallback(
		(toBeDeletedList) => {
			setTickets((oldValue) => {
				let tempList = oldValue[Object.keys(tickets)[selectedTab]];
				tempList = tempList.filter(({ id }) => {
					return !toBeDeletedList.includes(id);
				});

				const newValue = { ...oldValue, [Object.keys(tickets)[selectedTab]]: tempList };

				return newValue;
			});
		},
		[selectedTab, tickets]
	);

	const getTicketById = useCallback(
		(id) => {
			let selectedTicket = tickets[Object.keys(tickets)[selectedTab]].find((ticket) => {
				return id === ticket.id;
			});
			if (selectedTicket === undefined) {
				selectedTicket = tickets[Object.keys(tickets)[1 - selectedTab]].find((ticket) => {
					return id === ticket.id;
				});
			}

			return selectedTicket;
		},
		[tickets, selectedTab]
	);

	const respond = useCallback(
		(ticketId, response) => {
			setTickets((oldValue) => {
				const indexOfTicket = oldValue.open.findIndex((ticket) => {
					return ticket.id === ticketId;
				});
				const newValue = { ...oldValue };
				const messageObject = {
					sender: { user: `${name + " " + surname}`, company: companyName, color: companyColor },
					date: new Date(),
					message: response,
				};
				newValue.open[indexOfTicket].messages.push(messageObject);
				return newValue;
			});
		},
		[name, surname, companyName, companyColor]
	);

	// id: "2",
	// requestedBy: { user: "Kate Bush", color: COLORS[3] },
	// subject: "Just wanted to say hi",
	// tId: "T-112332",
	// status: "OPEN",
	// createdAt: "27/04/2022 12:40",
	// lastActivity: "27/04/2022 12:50",
	// assignedTo: "Can Karaman",
	// messages: [
	// 	{
	// 		sender: { user: "Kate Bush", color: COLORS[3] },
	// 		date: new Date(),
	// 		message: "Test Message",
	// 	},
	// ],

	const createTicket = useCallback((subject, message) => {
		// const now = new Date();
		// const newTicket = {
		// 	subject,
		// 	status: "OPEN",
		// 	createdAt: now,
		// 	lastActivity: now,
		// 	messages: [{ message, date: now }],
		// };
		// setTickets((oldValue) => {
		// 	const newValue = { ...oldValue };
		// 	newValue.open.push({});
		// });
	}, []);

	const closeTicket = useCallback((ticketId) => {
		setTickets((oldValue) => {
			const indexOfTicket = oldValue.open.findIndex((ticket) => {
				return ticket.id === ticketId;
			});
			const newValue = { ...oldValue };
			const ticketToBeClosed = newValue.open.splice(indexOfTicket, 1);
			ticketToBeClosed[0].status = "CLOSED";
			newValue.closed.push(...ticketToBeClosed);

			return newValue;
		});
	}, []);

	const value = useMemo(
		() => ({
			tickets,
			shownTickets,
			changeTab,
			deleteTickets,
			getTicketById,
			respond,
			createTicket,
			closeTicket,
		}),
		[
			tickets,
			shownTickets,
			changeTab,
			deleteTickets,
			getTicketById,
			respond,
			createTicket,
			closeTicket,
		]
	);
	return <TicketsContext.Provider value={value}>{children}</TicketsContext.Provider>;
};

export default TicketsProvider;
